import React from 'react';
import { useNavigate } from 'react-router';

import { Api } from '@core/api';
import { links } from '@core/router';
import { toast } from '@core/toast';
import { injectTSDI } from '@core/tsdi';

import {
    CalculatedMetricDefinitionForm,
    CalculatedMetricDefinitionFormData,
    toCreatePayload
} from './calculated-metric-definition-form';

export const CreateCalculatedMetricDefinition = () => {
    const navigate = useNavigate();
    const { fitnessActivityClient } = injectTSDI(Api);

    const handleSubmit = async (
        formData: CalculatedMetricDefinitionFormData
    ) => {
        await fitnessActivityClient.admin.workoutCalculatedMetricDefinitionControllerCreate(
            toCreatePayload(formData)
        );
        toast.success('Calculated metric created');
        navigate(links.calculatedMetricDefinitions());
    };

    return (
        <CalculatedMetricDefinitionForm
            title="Create Calculated Metric"
            submitLabel="Create"
            submittingLabel="Creating..."
            onCancel={() => navigate(links.calculatedMetricDefinitions())}
            onSubmit={handleSubmit}
        />
    );
};
